var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceDraftTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.66406C4.51562 1.66406 1.66504 4.51465 1.66504 7.9987C1.66504 11.4827 4.51562 14.3333 7.99967 14.3333C11.4837 14.3333 14.3343 11.4827 14.3343 7.9987C14.3343 4.51465 11.4837 1.66406 7.99967 1.66406ZM7.99967 13.0664C5.2061 13.0664 2.93197 10.7923 2.93197 7.9987C2.93197 5.20512 5.2061 2.93099 7.99967 2.93099C10.7932 2.93099 13.0674 5.20512 13.0674 7.9987C13.0674 10.7923 10.7932 13.0664 7.99967 13.0664ZM11.3554 5.65014C11.1082 5.40112 10.7056 5.40041 10.4575 5.64855L6.73275 9.37331L5.5391 8.18427C5.29208 7.9382 4.89246 7.93859 4.64592 8.18514C4.39903 8.43202 4.39903 8.8323 4.64592 9.07919L6.06086 10.4941C6.43193 10.8652 7.03356 10.8652 7.40464 10.4941L11.3539 6.5449C11.6008 6.298 11.6015 5.89791 11.3554 5.65014Z",
    fill: "#00A971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceDraftTick);
export default __webpack_public_path__ + "static/media/invoice-draft-tick.b77669262892033b99d2ebf5e50b3f54.svg";
export { ForwardRef as ReactComponent };